import { Pipe, PipeTransform } from '@angular/core'

/**
 * * TIMER PIPE
 * 
 * This custom pipe, named 'timer', is used to convert a timestamp into a string
 * in clock format (HH:MM:SS). It is designed to be used standalone, without requiring
 * any additional arguments in the template.
 *
 * Functionality:
 * - The input timestamp is converted into hours, minutes, and seconds.
 * - Hours, minutes, and seconds are formatted to always have two digits (prefixed by 0 if necessary).
 * - The function returns a string representing the time in the format HH:MM:SS.
 *
 * Example usage:
 * {{ timestampValue | timer }}
 *
 * where timestampValue is a number representing the number of seconds elapsed since a certain point in time.
 * This pipe can be used in Angular templates to display durations or clocks.
 */
@Pipe({
    name: 'timer',
    standalone: true
})
export class TimerPipe implements PipeTransform {
  transform(duration: number) {
    let s: number = duration % 60
    let m: number = ((duration % 3600) - s) / 60
    let h: number = (duration - m * 60 - s) / 3600

    const sec: string = s < 10 ? '0' + s : s.toString()
    const min: string = m < 10 ? '0' + m : m.toString()
    const hour: string = h < 10 ? '0' + h : h.toString()

    return `${hour}:${min}:${sec}`
  }
}
